import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";

const fragments =  {
	TEXT: '[data-fragment="OrderPickupSLPosta.text"]',
	BTN: '[data-fragment="OrderPickupSLPosta.btn"]',
	INPUT: '[data-fragment="OrderPickupSLPosta.input"]',
	PHONE: '[data-fragment="OrderPickupSLPosta.phone"]',
}

class OrderPickupSLPosta extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const {
		} = this.props;

		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);

		const textEl = this.element.querySelector(fragments.TEXT);
		const btnEl = this.element.querySelector(fragments.BTN);
		const inputEl = document.querySelector(fragments.INPUT);
		const phoneEl = document.querySelector(fragments.PHONE);

		const _self = this;

		this.on('click', fragments.BTN, (e) => {
			e.preventDefault();
			slposta.PickupWidget.open({
				callback: (pickupPoint) => {
					const address = pickupPoint.deliveryAddress.street + ', ' + pickupPoint.deliveryAddress.city + ' ' + pickupPoint.deliveryAddress.zip;
					_self.element.dataset.name = pickupPoint.label;
					_self.element.dataset.address = address;
					inputEl.value = pickupPoint.id;
					inputEl.dispatchEvent(new Event('change'));
					btnEl.innerText = 'Zmeniť výdajné miesto';
					textEl.innerHTML = `<b>${pickupPoint.label}</b><br/>(${address})`;
				},
			});
		});

		if(phoneEl) {
			this.on('change', fragments.PHONE, (e) => {
				this.sendData(e.target.value);
			});
		}
	}

	sendData = (phone) => {
		this.universalPreloaderComponent.handleOn(10);
		let dataJSON = [];
		let commitUrl = window.location.pathname + '?csrf=' + this.getCsrfToken() + this.getFormId() + '&eventName.storePickUpContactPhone';
		let xmlHttpReq = new XMLHttpRequest();
		let _self = this;
		dataJSON = [{
			branchId: document.querySelector('[name="frm.selectedBranchId"]').value,
			pickUpPointContactPhone: phone,
		}];
		xmlHttpReq.open('POST', commitUrl, true);
		xmlHttpReq.setRequestHeader("Content-Type", "application/json");
		xmlHttpReq.onreadystatechange = function () {
			if (xmlHttpReq.readyState === 4) {
				if (xmlHttpReq.status === 200) {
					// let data = xmlHttpReq.responseText;
					// console.log("onreadystatechange to server - " + data);
				}
			}
			_self.universalPreloaderComponent.handleOff(10);
		};
		xmlHttpReq.send(JSON.stringify(dataJSON));
	}

	getCsrfToken = () => {
		return document.querySelector('form input[name=csrf]').value;
	};

	getFormId = () => {
		let formId = document.querySelector('form input[name=formId]');
		if(formId) {
			return '&formId=' + formId.value;
		}
		return '';
	};
}
export default OrderPickupSLPosta;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/OrderPickupSLPosta.js